document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.hero-slideshow').forEach(function (root) {
    var slides = root.querySelectorAll('.hero-slideshow__slide');
    var dots = root.querySelectorAll('.hero-slideshow__dot');
    var prevBtn = root.querySelector('.hero-slideshow__arrow--prev');
    var nextBtn = root.querySelector('.hero-slideshow__arrow--next');
    var total = slides.length;
    if (total < 2) return;

    var current = 0;
    var autoplay = root.dataset.autoplay === 'true';
    var speed = parseInt(root.dataset.speed, 10) || 6000;
    var timer = null;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (index + total) % total;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(next, speed);
    }
    function stopAutoplay() {
      if (timer) clearInterval(timer);
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.index, 10));
        startAutoplay();
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  });
});